import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import Button from "@mui/material/Button";
const useStyles = makeStyles(theme => ({
  clearReset: {
    "&.MuiButton-root": {
      height: "2.5rem",
      width: "100%",
      fontSize: "1rem",
      padding: 0,
      backgroundColor: "#cdd7e3",
      fontWeight: 400,
      margin: 0,
      marginBottom: ".5rem",
    },
  },
}));
interface Props {
  buttonLabel: string;
  buttonType: "clear" | "reset";
  clearResetState: (report?: string, aggReport?: boolean) => void;
  report?: string;
  aggReport?: boolean;
}

export default function ClearReset({
  buttonLabel,
  report,
  buttonType,
  aggReport,
  clearResetState,
}: Props) {
  const classes = useStyles();
  const clearResetAction = () => {
    clearResetState(report, aggReport);
  };
  return (
    <Button
      color="secondary"
      className={classes.clearReset}
      id={buttonLabel.replace(/\s+/g, "-").toLowerCase()}
      onClick={clearResetAction}
      variant="contained"
      disableElevation
    >
      {buttonLabel}
    </Button>
  );
}
